export default __webpack_public_path__ + "8cbeef0a24c8f86b75e50a13b9a0a0a3.png";